import type { SelectableCardItem } from '@shared/ui/forms/SelectableCardList';
import type { EligibleLocation } from './api';

/** How a member knows the property: its street address, else its name. The code is only a last resort. */
export function formatAccessInviteLocationLabel(location: {
  name?: string | null;
  location_code?: string | null;
  label?: string | null;
  address?: string | null;
}): string {
  return (
    location.address?.trim() ||
    location.name ||
    location.label ||
    location.location_code ||
    'Property'
  );
}

/** Property cards: the address leads, the gate code sits underneath in muted text. */
export function toAccessInviteLocationCardItems(
  locations: EligibleLocation[],
): SelectableCardItem[] {
  return locations.map((location) => {
    const title = formatAccessInviteLocationLabel(location);
    return {
      id: location.location_id,
      title,
      // A code already used as the title is not repeated underneath.
      subtitle: location.location_code === title ? null : location.location_code,
    };
  });
}
